fragment JobsFragment on jobs_Entry {
  typeHandle
  iframeUrl
}
